import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import cookie from "js-cookie";
import { useRouter } from "next/router";
import Slider from "react-slick";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import axios from "axios";
import Head from "next/head";
import config from "../../../config";
function KitchenDesigns() {
  const [isReadMore, setIsReadMore] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  const submitGetInTouch = async () => {
    const namee = touch.name;
    const no = touch.number;
    const pin = touch.pincode;

    if (!namee || !no || !pin) {
      setTouch({
        ...touch,
        error: "All fields are required",
      });
    } else if (String(pin).length != 6) {
      setTouch({
        ...touch,
        error: "Invalid Pincode",
      });
    } else {
      setTouch({
        ...touch,
        error: "",
        loading: true,
      });
      let response = await getIntouch({
        name: namee,
        phone: no,
        pincode: pin,
      });
      if (response?.message) {
        localStorage.setItem("leadfilled", true);

        swal(response?.message);
        setTouch({
          ...touch,
          error: "",
          loading: false,
        });
      } else {
        swal(response.data.get_in_touch.msg);
        // setGetInTouch(false)

        setTouch({
          name: "",
          number: "",
          error: "",
          loading: false,
        });
        setIsExpertTalkClicked(false);
      }
    }
  };
  const settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: false,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 641,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  const settings2 = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: false,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 641,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };
  const [activeIndex, setActiveIndex] = useState(null);
  const router = useRouter();
  const [isExpertTalkClicked, setIsExpertTalkClicked] = useState(false);
  const [relatedBlogData, setRelatedBlogData] = useState([]);
  const [touch, setTouch] = useState({
    name: "",
    number: "",
    pincode: cookie.get("pincode"),
    error: "",
    loading: false,
  });
  const [selectedImage, setSelectedImage] = useState(null);
  const [show, setShow] = useState(false);
  const handleShow = (e) => {
    // Use event.target to get the image element
    const imgElement = e.target;
    if (imgElement && imgElement.src) {
      setSelectedImage(imgElement.src);
      setShow(true);
    }
  };
  const handleClose = () => setShow(false);
  const faqs = [
    {
      question: "How do I choose a good modular kitchen design in India?",
      alternateQuestion: null,
      answer:
        "To choose a good modular kitchen design in India, assess your kitchen layout, storage needs, and budget. Consider popular layouts like L-shaped or U-shaped for better workflow. Opt for new kitchen designs that offer both style and practicality, and match your home’s overall aesthetic for a cohesive look.",
    },
    {
      question: "What are the benefits of a modular kitchen?",
      alternateQuestion: null,
      answer:
        "Modular kitchens offer smart storage, sleek design, and easy customisation. They’re built to maximise space, enhance workflow, and are easier to install and maintain. These kitchen ideas are perfect for urban homes, blending functionality with style. You also get flexibility in layout, finish, and appliance integration.",
    },
    {
      question:
        "What type of material and finish is best for a modular kitchen?",
      alternateQuestion: null,
      answer:
        "For cabinets, plywood with a laminate or acrylic finish works best; laminate is durable and budget-friendly, while acrylic gives a premium sheen. Opt for glossy ceramic tiles on walls and backsplash for easy cleaning. Use vitrified matte or anti-skid tiles for safety on floors. Granite tiles are ideal for countertops due to their strength and heat resistance.",
    },
    {
      question:
        "What factors should I take into account while designing my kitchen?",
      alternateQuestion: null,
      answer:
        "A kitchen's layout efficiency, utility, storage requirements, and look preferences should all be taken into account. Ensure ample storage with cabinets and drawers and incorporate a mix of lighting for functionality and ambience. Choose appliances suited to your cooking habits, and select colours and finishes that reflect your style. Try to pick options that require minimal maintenance, like Orientbell Tiles’ kitchen tiles. You must also consider there is enough space for work, convenient access to different elements, and enough ventilation.",
    },
    {
      question: "How can I enlarge the space in a small kitchen?",
      alternateQuestion: null,
      answer:
        "You can incorporate vertical storage units, multi-functional furniture, and pull-out pantries to efficiently store items. Also, combine large-sized tiles to create the illusion of a large kitchen.",
    },
    {
      question: "What are the best kitchen lighting options?",
      alternateQuestion: null,
      answer:
        "You can consider using task, ambience, and accent lighting in your kitchen. Also, consider installing task lighting under cabinets, pendant lights, chandeliers, and ceiling lights for a stylish look.",
    },
    {
      question: "What are the most recent trends in kitchen design?",
      alternateQuestion: null,
      answer:
        "The most recent kitchen design trends blend practicality with style. Open-concept layouts foster social interaction, while minimalist modular kitchens with clean lines and cabinets with handles remain popular. Statement tiled backsplashes, featuring bold patterns and vibrant colours, paired with durable cabinet materials, add personal touches. Combining different colours like blue, green, grey, cream, black, and white is great to add a sophisticated touch.",
    },
    {
      question: "How can I give the kitchen's design some personality?",
      alternateQuestion: null,
      answer:
        "Combine bold colours, statement pieces, and unusual fittings, like pendant lights and cabinet handles or knobs, to give your kitchen a distinctive touch. To highlight your kitchen decor, you can consider including textured tile surfaces, artwork, and open shelving.",
    },
    {
      question:
        "Should I hire a professional kitchen designer or can I design my kitchen myself?",
      alternateQuestion:
        "Is it preferable to work with an expert or do it yourself when designing a kitchen?",
      answer:
        "Several considerations should be made when choosing whether to employ an expert designer or design your kitchen yourself. Your time constraints, financial constraints, level of confidence, and design expertise are a few of them. While designing it yourself offers more hands-on customisation and cost-saving possibilities, hiring a professional designer can give experience, industry insights, and specialised solutions.",
    },
  ];

  useEffect(() => {
    getRelatedBlogs();
  }, []);
  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  var requestOptions = {
    method: "GET",
  };
  const getRelatedBlogs = async () => {
    // try{
    let blogQuery =
      router.asPath.split("/")[router.asPath.split("/").length - 1];

    fetch(
      `${config.HEADLESS_BASE_URL}/blog/wp-json/post/v2/category/term=${blogQuery}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        setRelatedBlogData(JSON.parse(result));
      })
      .catch((error) => console.log("error", error));
  };
  const scrollToElement = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 100; // Adjust based on your header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const text = `Kitchen design plays a key role in shaping the vibe of your home. It's not just where you cook—it's where daily life unfolds, from morning tea to late-night chats. A good kitchen interior design balances beauty and function. It should be easy to move around, have enough storage, and suit your daily routine.
If you're planning a change, explore trendy and new kitchen design ideas. From contemporary layouts to clever storage solutions and high-end appliances, today’s modern kitchens are crafted to support your lifestyle while reflecting your taste. Whether you’re drawn to an open kitchen concept, a sleek L-shaped layout, or a cosy U-shaped setup, the right design can make all the difference. Take inspiration from our latest kitchen interior design ideas to build a space that works beautifully and feels just right.`;

  const maxChars = 300;
  const previewText = text.substring(0, maxChars);
  const remainingText = text.substring(maxChars);

  const displayedFAQs = showAll ? faqs : faqs.slice(0, 5);
  return (
    <>
      <Head>
        <title>
          Modular Kitchen Design Ideas & Inspirations | Orientbell Tiles
        </title>

        <meta
          name="title"
          content="Modular Kitchen Design Ideas & Inspirations | Orientbell Tiles"
        />
        <meta
          name="description"
          content=" Explore modular kitchen designs at Orientbell to enhance your space. Discover innovative kitchen design ideas for a functional and stylish cooking area."
        />
        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    ${faqs
      .map(
        (faq) => `
      {
        "@type": "Question",
        "name": "${faq.question}",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "${faq.answer}"
        }
      }
      ${
        faq.alternateQuestion
          ? `, {
        "@type": "Question",
        "name": "${faq.alternateQuestion}",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "${faq.answer}"
        }
      }`
          : ""
      }
    `
      )
      .join(",")}
  ]
}
`}
        </script>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Home",
                  item: "https://www.orientbell.com/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Design Ideas",
                  item: "https://www.orientbell.com/design-ideas/",
                },
                {
                  "@type": "ListItem",
                  position: 3,
                  name: "Kitchen Designs",
                  item: "https://www.orientbell.com/design-ideas/kitchen-designs",
                },
              ],
            }),
          }}
        ></script>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              url: "design-ideas/kitchen-designs",
              headline: "",
              breadcrumb: "Home > Design Ideas > Kitchen Designs",
              name: "Kitchen Design Ideas | Modern Kitchen Design | Orientbell Tiles",
              description:
                "Explore a wide range of kitchen designs and get modern kitchen design ideas for your kitchen with various shapes, colours, finishes and themes. Get Expert consultation!",
            }),
          }}
        ></script>
      </Head>
      <div class="designpage-section">
        <div class="container">
          <Breadcrumb>
            <Breadcrumb.Item href="https://www.orientbell.com">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas/">
              Design Ideas
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas/kitchen-designs">
              Kitchen Designs
            </Breadcrumb.Item>
          </Breadcrumb>

          <div class="designpage-heading-bx padding-spacing">
            <h1> Kitchen Designs</h1>
            <p className="description-text">
              {previewText}
              {!isReadMore && text.length > maxChars && "..."}
              {isReadMore && <span>{remainingText}</span>}
              {text.length > maxChars && (
                <button onClick={toggleReadMore}>
                  {isReadMore ? "Read Less" : "Read More"}
                </button>
              )}
            </p>
          </div>
          <div class="desi-page-category-col-bx">
            <div class="design-category-head-row">
              <Slider {...settings2}>
                <div>
                  <a
                    href="#Modular-Kitchen-Design"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Modular-Kitchen-Design");
                    }}
                  >
                    Modular Kitchen Design
                  </a>
                </div>
                <div>
                  <a
                    href="#Simple-Kitchen-Design"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Simple-Kitchen-Design");
                    }}
                  >
                    {" "}
                    Simple Kitchen Design
                  </a>
                </div>

                <div>
                  <a
                    href="#Small-Kitchen-Design"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Small-Kitchen-Design");
                    }}
                  >
                    {" "}
                    Small Kitchen Design
                  </a>
                </div>
                <div>
                  <a
                    href="#L-Shaped-Kitchen-Design"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("L-Shaped-Kitchen-Design");
                    }}
                  >
                    L-Shaped Kitchen Design
                  </a>
                </div>
                <div>
                  <a
                    href="#Open Kitchen Design Ideas"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Open Kitchen Design Ideas");
                    }}
                  >
                    Open Kitchen Design Ideas
                  </a>
                </div>
                <div>
                  <a
                    href="#White Design Ideas"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("White Design Ideas");
                    }}
                  >
                    White Design Ideas
                  </a>
                </div>

                <div>
                  <a
                    href="#Grey Design Ideas"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Grey Design Ideas");
                    }}
                  >
                    Grey Design Ideas
                  </a>
                </div>
                <div>
                  <a
                    href="#Beige and Brown Design Ideas"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Beige and Brown Design Ideas");
                    }}
                  >
                    Beige & Brown Design Ideas
                  </a>
                </div>
                <div>
                  <a
                    href="#Backsplash-Kitchen-Design"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Backsplash-Kitchen-Design");
                    }}
                  >
                    Kitchen Backsplash
                  </a>
                </div>
                <div>
                  <a
                    href="#Parallel-Kitchen-Design"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Parallel-Kitchen-Design");
                    }}
                  >
                    Parallel Kitchen
                  </a>
                </div>
              </Slider>
            </div>

            <div class="design-category-col-right">
              {/* Modular Kitchen */}
              <div class="designpage-category-wrap" id="Modular-Kitchen-Design">
                <h3>Modular Kitchen Design Gallery</h3>

                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Modular_Kitchen_Design/Linea_Decor_Travertine_Moroccan&DGVT_Classic_Travertine_Golden_600x1200mm.jpg"
                        alt="Linea Decor Travertine Moroccan & DGVT Classic Travertine Golden"
                      />
                    </div>
                    <div class="designpage-text">
                      <h3>
                        Modern Modular open kitchen design with brown cabinets
                      </h3>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Modular_Kitchen_Design/DR_PGVT_Elegant_Marble_Gold-Vein_600x1200mm.jpg"
                        alt="/DR PGVT Elegant Marble Gold Vein_600x1200 mm.jpg"
                      />
                    </div>
                    <div class="designpage-text">
                      <h3>Modular kitchen design with Wooden Design</h3>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Modular_Kitchen_Design/DR_Decor_Moroccan_Spanish_Art_Multi&_DR_DGVT_Sandstone_Beige_DK_600x1200mm.jpg"
                        alt="DR Decor Moroccan Spanish Art Multi & DR DGVT Sandstone Beige DK_600x1200 mm"
                      />
                    </div>
                    <div class="designpage-text">
                      <h3>
                        Modular Kitchen Design Ideas with beautiful backsplash{" "}
                      </h3>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Modular_Kitchen_Design/HBG_Venezia_Oak_Wood_DK_HAP_Anti-Skid_Rugged_Silver_300x300mm.jpg"
                        alt="HBG Venezia Oak Wood DK, HBG Soapstone Grey DK_300x450 mm_HAP Anti-Skid Rugged Silver_300x300 mm.jpg"
                      />
                    </div>
                    <div class="designpage-text">
                      <h3>Contemporary Staight Kitchen Design with cabinets</h3>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Simple Kitchen */}
              <div class="designpage-category-wrap" id="Simple-Kitchen-Design">
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h3>Simple Kitchen Design Gallery</h3>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="https://www.orientbell.com/design-ideas/kitchen-designs/simple-kitchen">
                      View all
                    </a>
                  </div>
                </div>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Classy simple kitchen design with textured grey tiles.webp"
                        alt="Classy simple kitchen design with textured grey tiles"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Classy Simple Kitchen Design with Textured Grey Tiles </h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Modern simple kitchen design with countertop.webp"
                        alt="Modern simple kitchen design with countertop"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Modern Simple Kitchen Design with Countertop</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Modern simple kitchen design with fruit themed.webp"
                        alt="Contemporary simple kitchen design with a blend of neutral tones"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Modern simple kitchen design with fruit themed</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design paired with neutral-toned cabinetry.webp"
                        alt="Simple Kitchen design with a matte finish cabinets"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Modern Small Wooden Kitchen Design with Wooden Cabinets</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Small Kitchen */}
              <div class="designpage-category-wrap" id="Small-Kitchen-Design">
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h4>Small Kitchen Design Gallery</h4>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="https://www.orientbell.com/design-ideas/kitchen-designs/small-kitchen">
                      View all
                    </a>
                  </div>
                </div>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Modular_Kitchen_Design/Small_Kitchen/DR_Decor_Protea_Flower-Art-&DR_DGVT_Mystery_Taupe_Grey_600x1200mm.jpg"
                        alt="DR Decor Protea Flower Art & DR DGVT Mystery Taupe Grey_600x1200 mm"
                      />
                    </div>
                    <div class="designpage-text">
                      <h3>
                        Simple & Small Kitchen Design With Flower Patterened
                        Wall{" "}
                      </h3>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Modular_Kitchen_Design/Small_Kitchen/Modern-Simple-Kitchen-Design-with-White-Flowed_Wall.jpg"
                        alt="DR Décor Rustic Maple Leaf Blue & DR DGVT Pulpis Marble Silver_600x1200 mm"
                      />
                    </div>
                    <div class="designpage-text">
                      <h3>
                        Modern Simple Kitchen Design with White Flowed Wall
                      </h3>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Modular_Kitchen_Design/Small_Kitchen/Modern-Small-Kitchen-Design-with-white-wall-design.jpg"
                        alt="kitchen design with white wall"
                      />
                    </div>
                    <div class="designpage-text">
                      <h3>
                        Modern Small Kitchen Design with white wall design
                      </h3>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Modular_Kitchen_Design/Small_Kitchen/ODM_Batik_Sandune,ODM_Batik_Crema&ODH_Batik-Leaf-HL_Kitchen_30x60CM.jpg"
                        alt="ODM Batik Sandune, ODM Batik Crema & ODH Batik Leaf HL_Kitchen_30x60 CM"
                      />
                    </div>
                    <div class="designpage-text">
                      <h3>
                        Modern Small Wooden Kitchen Design with Wooden Cabinets
                      </h3>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* L-Shaped Kitchen */}
              <div
                class="designpage-category-wrap"
                id="L-Shaped-Kitchen-Design"
              >
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h3>L-Shape Kitchen Design Gallery</h3>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="https://www.orientbell.com/design-ideas/kitchen-designs/l-shape-kitchen">
                      View all
                    </a>
                  </div>
                </div>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Modular_Kitchen_Design/L-Shaped_Kitchen/L-shaped_modular_kitchen_design_with_white_wall_Design.jpg"
                        alt="/GFT SPH Filmreel Floral Pink HL, GFT SPB Floral Grid White & GFT SPB Floral Grid Pink_Kitchen Ambiance_Ceramic Sparkle Wall Tiles_300x450 MM.jpg"
                      />
                    </div>
                    <div class="designpage-text">
                      <h3>
                        L-shaped modular kitchen design with white wall Design
                      </h3>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/HBG%206by4%20Bricks%20Grey&%20HBG%206by4%20Bricks%20Creama_300x450%20mm.jpg"
                        alt="L-shaped kitchen brick design"
                      />
                    </div>
                    <div class="designpage-text">
                      <h3>L-shaped Modular kitchen design with Brick design</h3>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Modular_Kitchen_Design/L-Shaped_Kitchen/HHG-Diamond-Ardesia_Marble_Brown&HBG_Ardesia_Marble_Creama_300x450mm.jpg"
                        alt="wood L-shape kitchen design"
                      />
                    </div>
                    <div class="designpage-text">
                      <h3>Classic dark wood L-shape kitchen design</h3>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Modular_Kitchen_Design/L-Shaped_Kitchen/OHG_Stargazer_Grey_HL,ODG_Armani_Marble_Grey-DK&ODG_Armani-Marble-Grey-LT_300x45mm.jpg"
                        alt="L-shaped Modular Kitchen Design"
                      />
                    </div>
                    <div class="designpage-text">
                      <h3>
                        L-shaped Modular Kitchen Design with Flower patterned
                        wall
                      </h3>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Open Kitchen */}
              <div
                class="designpage-category-wrap"
                id="Open Kitchen Design Ideas"
              >
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h3>Open Kitchen Design Gallery</h3>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="https://www.orientbell.com/design-ideas/kitchen-designs/open-kitchen">
                      View all
                    </a>
                  </div>
                </div>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Modular_Kitchen_Design/Open-Kitchen/Modular_open_Space_Kitchen_design_Ideas.jpg"
                        alt="modular open kitchen design"
                      />
                    </div>
                    <div class="designpage-text">
                      <h3>Modular open Space Kitchen design Ideas</h3>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <a href="#">
                        <img
                          src="https://images.orientbell.com/media/Oblimage/Modular_Kitchen_Design/Open-Kitchen/Open_Kitchen_Design_with_Grey&White_Colour_Combination.jpg"
                          alt="kitchen design with grey & white colour"
                        />
                      </a>
                    </div>
                    <div class="designpage-text">
                      <h3>
                        Open Kitchen Design with Grey & White Colour Combination
                      </h3>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* White Kitchen */}
              <div class="designpage-category-wrap" id="White Design Ideas">
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h3>White Kitchen Design Gallery</h3>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="https://www.orientbell.com/design-ideas/kitchen-designs/white-kitchen">
                      View all
                    </a>
                  </div>
                </div>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/White 23/300x450 SBG ROSALIA CUBE HL, SBG ROSALIA MARBLE DARK, SBG ROSALIA MARBLE LIGHT, SFM ROSALIA MARBLE DARK.webp"
                        alt="modular kitchen tiles design"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Modular open Space Kitchen design Ideas</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/White 23/300x450 SDH CINZA GREY HL & SDG CINZA GREY LT.webp"
                        alt="kitchen tiles design"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Open Kitchen Design with Grey & White Colour Combination</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/White 23/300x450 SDH CRARA TEA HL, SDG CRARA BIANCO.webp"
                        alt=""
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Open Kitchen Design with Grey & White Colour Combination</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/White 23/300x450 SHG AUTUMN STAR PETAL HL, SBG TUNDRA GREY DK, SBG TUNDRA GREY LT, SFM TUNDRA GREY DK.webp"
                        alt="kitchen pattern design"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Open Kitchen Design with Grey & White Colour Combination</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Grey Design Ideas */}
              <div class="designpage-category-wrap" id="Grey Design Ideas">
                <h3>Grey Kitchen Design Gallery</h3>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Grey 13/300x450 SDH HUNKER FLORA HL, SDG HUNKER GREY LT, SDG HUNKER GREY DK, SDM HUNKER GREY FL.webp"
                        alt="Grey Kitchen Design with chimney and cabinets"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Modular open Space Kitchen design Ideas</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Grey 13/300x450 SHG LOTUS MULTI HL, SBG N SLATE GREY DK, SBG N SLATE GREY LT, SFM N SLATE GREY DK.webp"
                        alt="Classic Grey Kitchen Design with designer backsplash tiles"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Open Kitchen Design with Grey & White Colour Combination</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Grey 13/300x450 SHG TRIANGLE MOSAIC HL, SBG RIVER WOOD SLATE, SBG RIVER WOOD GREY, SFM RIVER WOOD SLATE.webp"
                        alt="Luxurious Grey Kitchen Design with dining table set and a chimney"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Open Kitchen Design with Grey & White Colour Combination</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Grey 13/300x600 SDG BLOCOS GREY LT & SDG BLOCOS GRIS.webp"
                        alt="Modern Grey Kitchen Design with grey and white wall tiles"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Open Kitchen Design with Grey & White Colour Combination</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Beige and Brown */}
              <div
                class="designpage-category-wrap"
                id="Beige and Brown Design Ideas"
              >
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h3>Beige and Brown Kitchen Design Gallery</h3>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="https://www.orientbell.com/design-ideas/kitchen-designs/beige-and-brown-kitchen">
                      View all
                    </a>
                  </div>
                </div>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Beige & Brown 16/SHG TRAVERTINE MOSAIC HL & SBG NAVONA TRAVERTINE BEIGE_300x450mm.webp"
                        alt="Elegant Beige kitchen design featuring colourful backsplash tiles and a large window"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Modular open Space Kitchen design Ideas</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Beige & Brown 16/SHG HEXAGON DUAL HL, SBG OAK HARDWOOD BEIGE & SBG OAK HARDWOOD CREAMA _300x450mm.webp"
                        alt="Beige Kitchen Design with hexagonal print wall tiles"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Open Kitchen Design with Grey & White Colour Combination</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Beige & Brown 16/DR Decor Moroccan Spanish Art Multi & DR DGVT Sandstone Beige DK_600x1200 mm.webp"
                        alt="Elegant beige kitchen featuring an island design and Moroccan-inspired decorative wall tiles."
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Open Kitchen Design with Grey & White Colour Combination</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Beige & Brown 16/Kitchen - 300x600 - 300x300 SBG SONGKET VINE GOLD, SHG SONGKET FRUITS HL, SFM BOTTOCINO CREMA DK.webp"
                        alt="Stylish Beige Kitchen Design with black kitchen cabinets"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Open Kitchen Design with Grey & White Colour Combination</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Kitchen Backsplash */}
              <div
                class="designpage-category-wrap"
                id="Backsplash-Kitchen-Design"
              >
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h3>Kitchen Backsplash Design Gallery</h3>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="https://www.orientbell.com/design-ideas/kitchen-designs/kitchen-backsplash">
                      View all
                    </a>
                  </div>
                </div>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/Kitchen Backsplash/3D Fruit Pattern for Kitchen Backsplash Design.webp"
                        alt="Stylish kitchen backsplash design showcasing fruit-themed patterns."
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/Kitchen Backsplash/Blue Moroccan mosaic tiles for kitchen backsplash.webp"
                        alt="Stylish kitchen backsplash design with blue Moroccan mosaic tiles, grey cabinetry, and white grid wall tiles."
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/Kitchen Backsplash/Brown Herringbone Style on Kitchen Backsplash Design.webp"
                        alt="Sophisticated kitchen backsplash design with brown and white herringbone pattern."
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/Kitchen%20Backsplash/Coffee-Themed%20%20Kitchen%20Backsplash%20Design.webp"
                        alt="Elegant kitchen setup with coffee-themed tiles on the backsplash, white cabinetry, and a wooden countertop"
                        loading="lazy"
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Parallel Kitchen */}
              <div
                class="designpage-category-wrap"
                id="Parallel-Kitchen-Design"
              >
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h3>Parallel Kitchen Design Gallery</h3>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="https://www.orientbell.com/design-ideas/kitchen-designs/parallel-kitchen">
                      View all
                    </a>
                  </div>
                </div>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/Parallel/Elegant Parallel Kitchen Featuring Moroccan Backsplash.webp"
                        alt="Elegant Parallel Kitchen Featuring Moroccan Backsplash"
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/Parallel/Modern Parallel Kitchen with Black Countertop Design.webp"
                        alt="Modern Parallel Kitchen with Black Countertop Design"
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/Parallel/Sleek Parallel Kitchen with Hexagonal Floor Tiles.webp"
                        alt="Sleek Parallel Kitchen with Hexagonal Floor Tiles"
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/Parallel/Stylish Parallel Kitchen with blue mosaic tiles.webp"
                        alt="Stylish Parallel Kitchen with Blue Mosaic Tiles"
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Peninsula Design */}
              <div
                class="designpage-category-wrap"
                id="Peninsula-Kitchen-Design"
              >
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h3>Kitchen Peninsula Design Gallery</h3>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="https://www.orientbell.com/design-ideas/kitchen-designs/peninsula-kitchen">
                      View all
                    </a>
                  </div>
                </div>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Peninsula Kitchen 0/Modern Peninsula Kitchen Design with Wooden Cabinets.jpg"
                        alt="Modern Peninsula Kitchen Design with Wooden Cabinets"
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Peninsula Kitchen 0/Sleek Peninsula Kitchen Design with Dark Wood Cabinets.jpg"
                        alt="Sleek Peninsula Kitchen Design with Dark Wood Cabinets"
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Peninsula Kitchen 0/Elegant Peninsula Kitchen Design with Marble Wall Tiles.jpg"
                        alt="Elegant Peninsula Kitchen Design with Marble Wall Tiles"
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Blue Kitchen */}
              <div class="designpage-category-wrap" id="Blue-Kitchen-Design">
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h3>Blue Kitchen Design Gallery</h3>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="https://www.orientbell.com/design-ideas/kitchen-designs/blue-kitchen">
                      View all
                    </a>
                  </div>
                </div>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Blue 3/Blue Kitchen Design with Blue Mosaic Tiles.jpg"
                        alt="Kitchen design with blue mosaic tiles, wooden cabinets, white countertop, dining table, and modern decor."
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Blue 3/Modern Blue Kitchen Design with Blue Tile Backsplash.jpg"
                        alt="Modern kitchen design with blue tile backsplash, grey cabinets, white countertop, and stylish decor elements."
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Blue 3/Stylish Wooden Bathroom Design with modern Vanity.jpg"
                        alt="Contemporary Blue kitchen design with blue patterned backsplash, white cabinets and modern decor."
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Island Kitchen */}
              <div class="designpage-category-wrap" id="Island-Kitchen-Design">
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h3>Island Kitchen Design Gallery</h3>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="/design-ideas/kitchen-designs/island-kitchen">
                      View all
                    </a>
                  </div>
                </div>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Island Kitchen 4/Island Kitchen Design with Marble Backsplash.jpg"
                        alt="Island kitchen design with marble backsplash, dark cabinets and white countertop"
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Island Kitchen 4/Modern Island Kitchen Design with marble wall tiles.jpg"
                        alt="Modern island kitchen design with beige cabinets, and marble tiled wall"
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Island Kitchen 4/Sleek Island Kitchen Design with geomatric backsplash tiles.jpg"
                        alt="Sleek island kitchen design with dark wood cabinetry, geometric backsplash, and minimalist dining space with stools"
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/Island Kitchen 4/Stylish Island Kitchen design with 3D Wall Tiles.jpg"
                        alt="Stylish island kitchen design with 3D wall tiles, white cabinetry, modern lighting, and a cozy dining space"
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* I-shape Kitchen */}
              <div class="designpage-category-wrap" id="I-Shape-Kitchen-Design">
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h3>I-Shape Kitchen Design Gallery</h3>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="/design-ideas/kitchen-designs/i-shape-kitchen">
                      View all
                    </a>
                  </div>
                </div>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/l shape kitchen design 2/Contemporary I Kitchen Design with Mosaic Wall Tiles.jpg"
                        alt="Contemporary I kitchen design featuring mosaic-patterned wall tiles, sleek grey cabinets, and a modern chimney hood."
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/l shape kitchen design 2/Contemporary I Kitchen Design with patterned backsplash.jpg"
                        alt="Contemporary I kitchen design with wooden cabinets, modern lighting, sleek appliances, and stylish decor."
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/l shape kitchen design 2/Elegant I Kitchen Design with Coffee-Themed Tiles.jpg"
                        alt="Elegant I kitchen design featuring coffee-themed wall tiles, white cabinetry, wooden countertops, and modern appliances."
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/design-images/kitchen/l shape kitchen design 2/Elegant I Kitchen Design with Navy Cabinets.jpg"
                        alt="Elegant I kitchen design with navy cabinets, wooden countertop, decorative backsplash, modern sink, and natural lighting."
                      />
                    </div>
                    <div class="designpage-text">
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="designpage-detail-text padding-spacing">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/3oMTO_ACO2k?si=vBCbfIO5HZpmzFBG"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
            <h2>Why Choose a Modular Kitchen?</h2>
            <p>
              Modular kitchens often deliver satisfaction and joy because they
              are practical and stylish. From modern looks to smart layouts,
              modular kitchens can turn your ordinary kitchen into an
              environment that feels uniquely yours. The following points will
              help you recognise the benefits of modular kitchens.{" "}
            </p>
          </div>

          <div class="designpage-detail-text padding-spacing">
            <ul>
              <li>
                <h4>
                  <strong>Customisation</strong>
                </h4>
                <p>
                  Modular kitchens offer flexibility in design, allowing you to
                  pick the layout that matches your kitchen shape and needs. You
                  can explore various interior design layouts that can be
                  perfectly incorporated into your kitchen.
                </p>{" "}
              </li>
              <li>
                <h4>
                  <strong>Efficiency</strong>
                </h4>
                <p>
                  The design of modular kitchens optimises utility, offering
                  more storage and ease of movement. This can make your cooking
                  experience more organised and labour-saving.
                </p>{" "}
              </li>
              <li>
                <h4>
                  <strong>Durability</strong>
                </h4>
                <p>
                  With quality materials and installation, modular kitchens are
                  built to last, ensuring a long-lasting kitchen. Incorporate
                  our kitchen tile choices that need minimal upkeep, making them
                  perfect for kitchens.{" "}
                </p>
              </li>
              <li>
                <h4>
                  <strong>Inviting Ambience</strong>
                </h4>
                <p>
                  Modular kitchens contribute to a sleek and inviting interior
                  with well-organised elements, enhancing the overall appearance
                  of your home. Combine light tones tiles like soft neutrals or
                  muted pastels for warmth and a welcoming vibe. Adding{" "}
                  <a href="/tiles/large-tiles"> large tiles </a>
                  or tiles with subtle patterns can make your modular kitchen
                  feel more open and cohesive.
                </p>{" "}
              </li>
              <li>
                <h4>
                  <strong>Versatility</strong>
                </h4>
                <p>
                  Modular kitchens come in diverse styles, letting you craft a
                  kitchen that matches your home’s decor and personal taste.
                  Choosing a modular kitchen brings multiple benefits that can
                  upgrade your kitchen with a stylish, long-lasting solution.
                </p>{" "}
              </li>
            </ul>
          </div>
          <div class="designpage-detail-text padding-spacing">
            <h2>Different Types of Modular Kitchen Designs</h2>
            <p>
              Modular kitchens offer the perfect balance of style, convenience,
              and practicality. These layouts are designed to suit different
              home sizes and user preferences. From compact city apartments to
              larger homes, you can explore the best kitchen designs that
              combine smart layout with visual appeal.{" "}
            </p>
            <ul>
              <li>
                <h4>
                  <strong>L-Shaped Kitchen Layout</strong>
                </h4>
                <p>
                  This layout uses two adjoining walls, making the most of the
                  corner space. It's perfect for small to medium-sized homes and
                  allows for easy movement while cooking. It's one of the latest
                  kitchen designs that supports functionality without cluttering
                  the space.
                </p>
              </li>
              <li>
                <h4>
                  <strong>U-Shaped Kitchen Layout</strong>
                </h4>
                <p>
                  Designed for larger kitchens, this layout includes three
                  connected walls that offer maximum countertop and storage
                  space. Some also feature a central island, perfect for meal
                  prep or casual dining. It adds flow and comfort to everyday
                  cooking.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Straight Kitchen Layout</strong>
                </h4>
                <p>
                  Ideal for compact homes or studio apartments, everything is
                  placed along a single wall. This setup is easy to maintain and
                  provides a clean, modern look. With clever storage, even a
                  small kitchen can feel spacious.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Galley Kitchen Layout</strong>
                </h4>
                <p>
                  In this layout, two parallel walls house the cabinets and
                  appliances. It’s a functional setup often seen in modern urban
                  homes. It promotes an efficient work triangle, making cooking
                  and cleaning more streamlined.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Island Kitchen Layout</strong>
                </h4>
                <p>
                  Popular in open kitchens, this layout features a free-standing
                  island that can be used for cooking, serving, or entertaining.
                  It enhances the kitchen’s visual appeal and adds a social
                  element to the space.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Peninsula Kitchen Layout</strong>
                </h4>
                <p>
                  This design includes an extended counter attached to a wall or
                  cabinet, resembling an island but requiring less room. It's a
                  great choice if you want more prep space in a semi-open
                  kitchen plan.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Parallel Kitchen Layout</strong>
                </h4>
                <p>
                  Also known as a double galley, this design features two long
                  counters opposite each other. It's ideal for efficient
                  cooking, with separate zones for prep and cleaning. This
                  layout is often recommended in kitchen interior design ideas
                  for its practicality.
                </p>
              </li>
            </ul>
          </div>
          <div class="designpage-detail-text padding-spacing">
            <h2>Design Your Kitchen Interiors Based on Themes</h2>
            <p>
              Designing your kitchen interiors around a specific style adds
              personality and purpose. It helps transform a basic setup into a
              space that feels warm, stylish, and truly yours. Whether you have
              an L-shaped, U-shaped, or open kitchen layout, here are some
              popular styles to draw inspiration from:{" "}
            </p>
            <ul>
              <li>
                <h4>
                  <strong>Contemporary Style</strong>
                </h4>
                <p>
                  A contemporary kitchen focuses on clean lines, sleek surfaces,
                  and modern elements. It's all about minimalism and
                  functionality. Neutral colours and smart storage solutions
                  help maintain a clutter-free look. This is one of the best
                  kitchen designs for urban homes looking for elegance and
                  efficiency.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Traditional Style </strong>
                </h4>
                <p>
                  A traditional kitchen design reflects warmth, charm, and a
                  timeless character. Think of vintage elements, earthy colours,
                  and intricate detailing. This style brings a homely,
                  comforting vibe—perfect for those who love a familiar and
                  welcoming kitchen setup.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Industrial Style</strong>
                </h4>
                <p>
                  Inspired by warehouse-style interiors, the industrial look
                  blends raw materials with simple finishes. The focus here is
                  on functionality, open shelving, and rugged finishes. It's
                  ideal for people who want a minimal yet edgy kitchen.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Rustic Style</strong>
                </h4>
                <p>
                  A rustic kitchen evokes the charm of countryside living. With
                  natural textures, earthy tones, and vintage accents, this
                  style creates a cosy and lived-in feel. It's a great pick if
                  you want a unique, warm, and full-of-character kitchen.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Luxury Style</strong>
                </h4>
                <p>
                  A luxury interior design kitchen is all about sophistication
                  and high-end appeal. From premium finishes to thoughtfully
                  designed elements, every detail adds to the grandeur. This
                  style is perfect for those who love elegance with a touch of
                  opulence.
                </p>
              </li>
            </ul>
          </div>

          {/* Essential Elements of Kitchen Unit Designs */}
          <div class="designpage-detail-text padding-spacing">
            <h2>Essential Elements of Kitchen Unit Designs</h2>
            <p>
              Designing the perfect kitchen requires more than a beautiful look;
              functionality is equally important. The right kitchen unit design
              can elevate your cooking space, making it both practical and
              stylish. Let’s explore the essential elements you should consider
              when designing a kitchen to suit your needs and lifestyle.{" "}
            </p>
            <ul>
              <li>
                <h4>
                  <strong>Storage Solutions</strong>
                </h4>
                <p>
                  Storage is one of the most crucial elements in any kitchen
                  design. Practical storage solutions keep your kitchen
                  organised and clutter-free. From built-in shelves to pull-out
                  drawers and cabinets, maximising your storage capacity allows
                  for easy access to utensils, pots, and pans. Thoughtful
                  storage solutions are vital for maintaining a clean and
                  efficient kitchen.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Countertop Space</strong>
                </h4>
                <p>
                  Countertops are essential in any kitchen design, providing
                  space for preparing meals and storing kitchen essentials.
                  Choose materials like quartz, granite, or marble that offer
                  durability, heat resistance, and ease of maintenance.
                  Maximising countertop space ensures there’s always room for
                  cooking tasks and keeps your kitchen functional.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Functional Layout</strong>
                </h4>
                <p>
                  A well-planned layout is one of the most important aspects of
                  kitchen interior design ideas. The kitchen work triangle,
                  which connects the stove, fridge, and sink, should be
                  optimised for easy movement between these areas. A practical
                  layout improves workflow and enhances the efficiency of daily
                  kitchen tasks. Popular layouts include L-shaped, U-shaped, and
                  island kitchens.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Cabinet Design</strong>
                </h4>
                <p>
                  Cabinet design is an essential element of the latest kitchen
                  designs. Choose between open shelving for a modern, airy feel
                  or closed cabinets for a more streamlined look. Consider
                  factors like size, placement, and materials when designing
                  your cabinetry to enhance your kitchen's aesthetics and
                  practicality.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Lighting</strong>
                </h4>
                <p>
                  Proper lighting is critical for your kitchen's functionality
                  and ambience. Incorporate task, ambient, and accent lighting
                  to illuminate work areas, create atmosphere, and highlight
                  design features. Under-cabinet lighting, pendant lights, and
                  recessed lighting are excellent ways to ensure your kitchen is
                  well-lit and inviting.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Ergonomics and Accessibility</strong>
                </h4>
                <p>
                  Focus on ergonomics to ensure your kitchen is user-friendly.
                  Frequently used items should be easily accessible to minimise
                  strain. Adjustable counters, easy-to-open cabinets, and
                  properly placed appliances contribute to a comfortable and
                  efficient kitchen environment.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Aesthetic Appeal</strong>
                </h4>
                <p>
                  Finally, your kitchen's aesthetic appeal should match your
                  personal style. Whether you prefer a modern, sleek design or a
                  more rustic, traditional feel, choose elements that complement
                  each other. From colour schemes to textures, make sure your
                  kitchen design reflects your taste while maintaining a
                  cohesive look.
                </p>
              </li>
            </ul>
          </div>

          {/* The Importance of Colour Schemes in Kitchen Interior Design */}
          <div class="designpage-detail-text padding-spacing">
            <h2>The Importance of Colour Schemes in Kitchen Interior Design</h2>
            <p>
              When it comes to kitchen design, the colour scheme plays a
              significant role in shaping the overall look and feel of the
              space. Choosing the right colours can transform your kitchen into
              a place of comfort, energy, or relaxation, depending on the
              atmosphere you want to create. Here’s why colour schemes are
              crucial in kitchen interior design.
            </p>
            <ul>
              <li>
                <h4>
                  <strong>Creating the Right Atmosphere</strong>
                </h4>
                <p>
                  The colour scheme is essential in setting the tone for your
                  kitchen. Soft, neutral shades like whites, greys, and beige
                  can create a calm, clean environment that feels spacious and
                  welcoming. Meanwhile, vibrant colours like deep blues, greens,
                  or even fiery oranges can infuse energy into the space, making
                  it more dynamic and lively. Selecting the right kitchen design
                  colours helps craft an atmosphere that suits your lifestyle.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Visual Appeal and Aesthetic Balance</strong>
                </h4>
                <p>
                  Visual harmony is key in any kitchen design. The right colour
                  palette enhances the overall aesthetics of the kitchen. For
                  example, pairing earthy tones with white accents creates a
                  modern yet warm space. Trends in new kitchen designs often
                  feature balanced colour combinations, like matte greys with
                  natural wood tones or bold accents against neutral
                  backgrounds, providing a stylish and cohesive look.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Making the Space Look Larger or Cosier</strong>
                </h4>
                <p>
                  Colours have the power to influence how large or small your
                  kitchen feels. Lighter shades, such as off-whites and pastels,
                  can make even the smallest kitchens look more spacious and
                  airy. Darker colours, like navy or charcoal, add depth and
                  make large kitchens feel more intimate and cosy. Depending on
                  your kitchen ideas, you can use colours to expand or reduce
                  the perception of space visually.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Highlighting Key Features</strong>
                </h4>
                <p>
                  Strategically using colour helps draw attention to essential
                  elements in your kitchen. For instance, contrasting colours
                  for your kitchen island or cabinetry can make them stand out
                  as focal points. With kitchen design ideas, you can
                  incorporate a bold backsplash or accent walls to add character
                  and highlight specific features of the space. Thoughtful
                  colour choices enhance the visual impact of these areas.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Improved Functionality</strong>
                </h4>
                <p>
                  Functionality is another essential reason for choosing the
                  right colours for your kitchen interior design. Lighter
                  colours reflect more light, making your kitchen brighter and
                  more inviting. On the other hand, darker colours are known to
                  hide dirt and stains better, making them practical for
                  high-use areas. By considering both the aesthetic appeal and
                  practicality of colours, you can ensure that your kitchen
                  design is both beautiful and functional.
                </p>
              </li>
              <li>
                <h4>
                  <strong> Cohesiveness with the Rest of Your Home </strong>
                </h4>
                <p>
                  Your kitchen should feel like an extension of the rest of your
                  home. When deciding on a house kitchen design, it’s essential
                  to think about how your kitchen colours will complement the
                  overall theme of your home. Whether you go for a modern look,
                  rustic charm, or classic elegance, ensure the colour scheme
                  aligns with the rest of your interior design. This creates a
                  cohesive flow throughout your living spaces.
                </p>
              </li>
            </ul>
          </div>

          {/* Removed By Seo Team (21-04-2025) */}
          {/* <div class="designpage-detail-text padding-spacing">
            <h2> Common Kitchen Cabinet Materials</h2>
            <p>
              When choosing kitchen cabinet materials, you may find multiple
              options, but you have to pick them according to your style and
              budget.{" "}
            </p>
            <ul>
              <li>
                <h4>
                  <strong>Timber</strong>
                </h4>
                <p>
                  One of the most preferred choices is wood, which can be made
                  from various types of timber. They offer a classic, warm look
                  that suits many interiors of varying kitchen shapes.
                </p>
              </li>
              <li>
                <h4>
                  <strong>MDF</strong>
                </h4>
                <p>
                  You can consider MDF, which is made from wood fibres and
                  resin, making it quite affordable and durable.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Plywood</strong>
                </h4>
                <p>
                  Plywood is hardwearing and can bear water splashes, as it is
                  made from layers of wood veneers. It is a strong option for
                  cabinets, though it can cost more than MDF.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Laminate</strong>
                </h4>
                <p>
                  {`If you need a cabinet material that is easy to maintain, go
                  for laminate cabinets with a synthetic outer layer over the
                  particleboard. They come in various colours and patterns,
                  perfectly matching your backsplash tiles and kitchen's
                  interior design.`}
                </p>
              </li>
              <li>
                <h4>
                  <strong>Stainless Steel</strong>
                </h4>
                <p>
                  You can consider the stainless steel options, often chosen for
                  contemporary kitchen interiors for their excellent features
                  like a sleek, modern look, and resistance to stains and heat.
                </p>
              </li>
            </ul>

            <p>
              So, regardless of kitchen shape or how you use them, these kitchen
              cabinet materials offer durability, style, and easy maintenance.
            </p>
          </div> */}

          <div class="designpage-detail-text padding-spacing">
            <h2> Guide to Choose Perfect Kitchen Design</h2>
            <p>
              Choosing the perfect kitchen design can be a daunting task, but
              it’s essential to create a space that blends style, functionality,
              and practicality. Whether you're renovating your kitchen or
              designing a new one, the right design can transform your home.
              Here’s a guide to help you navigate the process and select the
              kitchen design that best fits your needs.
            </p>
            <ul>
              <li>
                <h4>
                  <strong>Budgeting for Your Dream Kitchen</strong>
                </h4>
                <p>
                  It's essential to plan your budget before diving into the
                  design process. The cost of materials, labour, and appliances
                  can add up quickly. Choose a design that balances your vision
                  and your budget. Sometimes, opting for custom cabinetry or
                  high-end countertops might not fit your financial plans, but
                  there are plenty of cost-effective alternatives that still
                  offer great style and functionality.
                </p>
              </li>
              <li>
                <h4>
                  <strong> Understand Your Kitchen Layout </strong>
                </h4>
                <p>
                  Start by determining the layout that best suits your space and
                  cooking style. Popular kitchen interior design ideas include
                  L-shaped, U-shaped, straight, and galley designs. Each layout
                  has its benefits depending on the size and shape of your
                  kitchen. For instance, L-shaped kitchens maximise corner
                  space, while U-shaped kitchens provide ample countertop space
                  for larger kitchens. Consider your room for workstations,
                  storage, and movement flow.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Focus on Functionality</strong>
                </h4>
                <p>
                  Functionality should be at the heart of your house kitchen
                  design. Think about how you use your kitchen daily. Do you
                  enjoy hosting family dinners? Do you prefer cooking in
                  solitude? The right design should enhance your workflow, from
                  prepping to cooking to cleaning. Ensure the kitchen layout
                  offers easy access to storage and appliances while maintaining
                  an open flow.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Consider Your Style</strong>
                </h4>
                <p>
                  The kitchen design should reflect your personal style. From
                  modern to traditional, sleek and minimalist to rustic charm,
                  there are plenty of options to choose from. Explore new
                  kitchen designs with bold finishes like matte black or brushed
                  metal accents if you prefer clean, contemporary lines. On the
                  other hand, if a more cosy, farmhouse-inspired look speaks to
                  you, go for wooden accents, vintage fixtures, and warmer
                  tones.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Think About Storage Solutions</strong>
                </h4>
                <p>
                  Storage is one of the most important factors when choosing a
                  kitchen design. A clutter-free kitchen promotes both style and
                  function. Look for smart storage solutions like pull-out
                  pantries, drawer dividers, and overhead cabinets that maximise
                  space. The right storage can make all the difference in a
                  small kitchen or a kitchen with limited storage space.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Lighting Matters</strong>
                </h4>
                <p>
                  Lighting is crucial in any kitchen interior design. A well-lit
                  kitchen is not only safer to work in but also enhances its
                  overall aesthetic. Include a mix of task, ambient, and accent
                  lighting in your design. Under-cabinet lighting, pendant
                  lights above the kitchen island, and recessed lighting can
                  bring out the beauty of your design while ensuring good
                  visibility.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Choose the Right Materials</strong>
                </h4>
                <p>
                  Selecting the right materials is key to a functional and
                  stylish kitchen. Granite tiles, alongside quartz and marble,
                  are a popular choice for countertops due to their durability
                  and sleek look. For cabinetry, laminate or solid wood offers
                  both practicality and aesthetic value. The focus in new
                  kitchen designs is on surfaces that are easy to maintain yet
                  visually appealing. For walls and backsplashes, go for glossy
                  ceramic tiles. They reflect light, are easy to wipe clean, and
                  add a polished finish to the kitchen. For flooring, vitrified
                  tiles with a matte or anti-skid finish ensure safety while
                  maintaining a modern look, especially in wet zones.
                </p>
              </li>
              <li>
                <h4>
                  <strong> Incorporate Technology </strong>
                </h4>
                <p>
                  Modern kitchens often include innovative technology to make
                  cooking easier and more enjoyable. Consider adding
                  energy-efficient appliances, smart refrigerators, or automated
                  lighting and faucets. These technologies not only increase the
                  functionality of your kitchen but also provide a modern edge
                  to your kitchen design.
                </p>
              </li>
              <li>
                <h4>
                  <strong> Colour Scheme </strong>
                </h4>
                <p>
                  The colours you choose for your kitchen will set the tone for
                  the entire space. Light colours like white, grey, and beige
                  can make a small kitchen feel larger. At the same time, darker
                  hues like navy or charcoal can create a cosy, intimate
                  environment. Think about how the colours will complement the
                  rest of your home’s design. Whether you prefer bright, bold
                  accents or neutral tones, make sure your colour palette fits
                  your overall theme.
                </p>
              </li>
              <li>
                <h4>
                  <strong>Personal Touches</strong>
                </h4>
                <p>
                  Lastly, your kitchen should feel like home. Don’t be afraid to
                  include personal touches, such as custom shelving, decorative
                  backsplash tiles, or unique accessories that add character.
                  These small additions can make your kitchen feel more inviting
                  and tailored to your needs.
                </p>
              </li>
            </ul>
          </div>

          <div class="designpage-latest-design padding-spacing">
            <h2>Get Latest Kitchen Design Ideas By Expert Designer</h2>

            <button
              class="talk-expert-btn talk-to-expert-design-page bottom-section"
              onClick={() => {
                setIsExpertTalkClicked(true);
              }}
            >
              Talk to Expert
            </button>
          </div>

          <div className="designpage-faq-section padding-spacing">
            <h2>FAQs About Kitchen Design</h2>
            <div className="newacd designpage-faq-row">
              <ul className="accordion">
                {displayedFAQs.map((faq, index) => (
                  <li key={index}>
                    <a className="toggle" onClick={() => handleToggle(index)}>
                      {index + 1}. {faq.question}{" "}
                      {faq.alternateQuestion && ` / ${faq.alternateQuestion}`}
                    </a>
                    {activeIndex === index && (
                      <ul className="inner">
                        <li>{faq.answer}</li>
                      </ul>
                    )}
                  </li>
                ))}
              </ul>

              {faqs.length > 5 && (
                <div className="tru_btn_new design-page">
                  <button
                    className="btn btn-primary"
                    onClick={() => setShowAll(!showAll)}
                  >
                    {showAll ? "Show Less" : "Read More"}
                  </button>
                </div>
              )}
            </div>
          </div>

          {relatedBlogData?.length > 0 && (
            <div className="tile-related-blog">
              <h2 className="title">Related Blogs</h2>
              <div className="designpage-relatedpost-row">
                <Slider {...settings}>
                  {relatedBlogData?.map((obj, index) => {
                    return (
                      <div className="related-blog-col" key={index}>
                        <div className="blog-figure">
                          <a href={obj.permalink}>
                            <img
                              src={obj.image}
                              loading="lazy"
                              alt="Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                            />
                          </a>
                        </div>
                        <div className="blog-text">
                          <div className="listingDate">{obj.date}</div>
                          <div className="listingHead">
                            <a href={obj.permalink}>
                              <div
                                dangerouslySetInnerHTML={{ __html: obj.title }}
                              />
                            </a>
                          </div>
                          <div className="listingText">
                            <p>
                              {" "}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: obj.content.slice(0, -11),
                                }}
                              />
                            </p>
                            <div className="listingButton">
                              <a href={obj.permalink}>Read More</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal
        className="image-zoom-view-modal"
        show={show}
        autoFocus
        onHide={handleClose}
      >
        <Modal.Dialog>
          <Modal.Header closeButton />

          {selectedImage && <img height="400px" src={`${selectedImage}`}></img>}
        </Modal.Dialog>
      </Modal>

      <Modal
        show={isExpertTalkClicked}
        className="pincode-popup-bx expert_assistance_modal ask-question-popup"
        onHide={() => {
          // setTimePopup(false)
          // setGetInTouch(false)
          setIsExpertTalkClicked(false);
          // localStorage.setItem('leadSkiped',true)
        }}
      >
        <Modal.Dialog>
          <Modal.Header closeButton>
            <Modal.Title>Get in touch with our tile expert</Modal.Title>
          </Modal.Header>
          <div className="ask-question-section">
            <div className="expert-fig-bx">
              <img src="/new-tareek.jpg" />
            </div>
            <Modal.Body>
              <h2>Ask Tile Expert</h2>
              <p>Let Experts Help You In Buying Process</p>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  submitGetInTouch();
                }}
              >
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        name: e.target.value,
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Mobile</Form.Label>

                  <Form.Control
                    type="number"
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        number: `${touch.countryCode || ""}${e.target.value}`, // Append the country code
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="number"
                    value={touch.pincode}
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        pincode: e.target.value,
                      });
                    }}
                  />
                </Form.Group>

                {touch.error && (
                  <p className="error text-danger">{touch.error}</p>
                )}

                <Button
                  variant="primary"
                  type="submit"
                  disabled={touch.loading}
                  style={{ width: "100%" }}
                >
                  {touch.loading ? "Submitting" : "Submit"}
                </Button>
              </Form>
            </Modal.Body>
          </div>
          {/* <Modal.Footer>
              <Button variant="primary" onClick={() => handlePinSave()}>
                Submit
              </Button>
            </Modal.Footer> */}
        </Modal.Dialog>
      </Modal>
    </>
  );
}

export default KitchenDesigns;
